import React from 'react';
import styled from '@emotion/styled';
import ConsumablePurchase from './ConsumablePurchase';
import Empty from './Empty';
import PeriodicPurchase from './PeriodicPurchase';
import Subscription from './Subscription';
import useInventoryItemList from './useInventoryItemList';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${({
  theme
}) => theme.screenSize.mobile} {
    gap: 20px;
  }
`;
const ItemList: React.FC = () => {
  const {
    consumableItems,
    periodicItems,
    subscriptionItems
  } = useInventoryItemList();
  const hasItems = !!subscriptionItems?.length || !!consumableItems?.length || !!periodicItems?.length;
  if (!hasItems) {
    return <Empty />;
  }
  return <Container data-sentry-element="Container" data-sentry-component="ItemList" data-sentry-source-file="ItemList.tsx">
      {!!subscriptionItems?.length && <Subscription items={subscriptionItems} />}
      {!!consumableItems?.length && <ConsumablePurchase items={consumableItems} />}
      {!!periodicItems?.length && <PeriodicPurchase items={periodicItems} />}
    </Container>;
};
export default ItemList;